import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import PageTemplate from '../../components/template/PageTemplate/PageTemplate';
import { VERSION_DETAIL_PAGE_TYPE, VERSION_PAGE_NAME } from '../../constants/service/app/versionConstants';
import VersionDetailContainer from '../../containers/version/VersionDetailContainer';
import { versionActions } from '../../store/modules/version';

class VersionCreate extends Component {
  render() {
    const { insertVersion } = this.props;

    return (
      <PageTemplate pageName={VERSION_PAGE_NAME.VERSION_CREATE}>
        <VersionDetailContainer pageType={VERSION_DETAIL_PAGE_TYPE.CREATE} onSubmit={insertVersion} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  insertVersion: versionActions.insertVersion,
};

export default connect(null, mapDispatchToProps)(withRouter(VersionCreate));
